import styled, { css } from 'styled-components';

export const StyledMyAuditDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  margin-top: 88px;
  margin-bottom: 83px;
`;

export const DetailsHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const BenchmarkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.m} 0;
`;

export const BenchmarkScoreWrapper = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const SectionDetail = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionName = styled.a`
  text-decoration: underline;
`;

export const SectionWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.platinum};
  padding: ${({ theme }) => theme.spacing.m};
`;

export const ButtonWithIcon = styled.button(
  ({ theme, borderColor, backgroundColor = 'white' }) => css`
    border: 1px solid ${borderColor};
    border-radius: ${theme.radius.xs};
    background-color: ${theme.colors[backgroundColor]};
    height: ${theme.spacing.l};
    width: ${theme.spacing.l};
    display: flex;
    justify-content: center;
    align-items: center;
  `
);

export const ButtonsDetailContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.s};
  justify-content: flex-end;
  margin: ${({ theme }) => theme.spacing.s} 0;
`;

export const BenchmarkTitleContainer = styled.div`
  width: 80%;
`;
